<template>
  <div>
    <b-container fluid align-v="center">
      <h5 class="text-left float-left">登録済{{ displayName }}</h5>
      <router-link :to="nextLink" class="btn btn-outline-secondary float-right">新規作成</router-link>
    </b-container>
    <b-table
      :fields="fields"
      :items="items"
      :sort-by.sync="sortBy"
      :sort-asc.sync="sortAsc"
      bordered>
      <template v-slot:cell(no)="data" >
        <router-link :to="{ path: childLink(data.value) }">{{ data.value }}</router-link>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: 'ChildList',
  props: ['items', 'object', 'parent_id'],
  data () {
    return {
      sortBy: 'no',
      sortAsc: true,
      fields: [
        { key: 'no', sortable: true },
        { key: 'name', sortable: true }
      ]
    }
  },
  computed: {
    displayName () {
      const childName = this.childRelations[this.object]
      return this.translate[childName] || ''
    },
    nextLink () {
      return `/${this.childRelations[this.object]}?parent_id=${this.parent_id}`
    }
  },
  methods: {
    childLink (to) {
      return `/${this.childRelations[this.object]}/${to}?parent_id=${this.parent_id}`
    }
  }
}
</script>
